import { Button } from '@/components/ui/Button';
import { useRetryExecution } from '@/hooks/useAdminAutomations';
import { RotateCcw } from 'lucide-react';

interface RetryButtonProps {
  executionUuid: string;
}

export function RetryButton({ executionUuid }: RetryButtonProps) {
  const retry = useRetryExecution();
  return (
    <Button
      variant="outline"
      size="sm"
      icon={<RotateCcw className="h-3.5 w-3.5" />}
      onClick={() => retry.mutate(executionUuid)}
      loading={retry.isPending}
    >
      Relancer
    </Button>
  );
}
